import DataFieldManagerUtils from 'components/DataFieldManager/DataFieldManagerUtils';

const AssignedTechIdRowData = metadata => {
	return {
		zoneId: metadata.zoneId,
		serviceId: metadata.serviceId,
		centralId: metadata.centralId,
		assignedTechId: metadata.assignedTechId,
		assignedTechName: metadata.assignedTechName,
	};
};

const EventIdRowData = metadata => {
	return {
		odtId: metadata.odtId,
		eventId: metadata.eventId,
		eventName: metadata.eventName,
	};
};

const WarrantyRowData = metadata => {
	return {
		isBilled: metadata.eventProps?.billed,
	};
};

const ServiceIdRowData = (metadata, cleanElementView) => {
	return {
		serviceId: metadata.serviceId,
		serviceName: metadata.serviceName,
		eventProps: metadata.eventProps,
		orderTargetId: metadata.orderTargetId,
		cleanElementView,
	};
};

export default class BuildDependencyRowData {
	constructor(field, metadata, cleanElementView) {
		this.field = field;
		this.metadata = metadata;
		this.cleanElementView = cleanElementView;
	}

	_getBuilder() {
		const { ASSIGNED_TECH_ID, EVENT_ID, IS_WARRANTY, SERVICE_ID } =
			DataFieldManagerUtils.getFieldIds();

		return {
			[ASSIGNED_TECH_ID]: AssignedTechIdRowData,
			[EVENT_ID]: EventIdRowData,
			[IS_WARRANTY]: WarrantyRowData,
			[SERVICE_ID]: ServiceIdRowData,
		}[this.field.id];
	}

	run() {
		const builder = this._getBuilder();
		const customConfig = builder
			? builder(this.metadata, this.cleanElementView)
			: {};

		return {
			[this.field.id]: this.field.uiValue || this.field.value,
			...customConfig,
			id: this.metadata.orderId,
		};
	}
}
